import React, {Fragment, useEffect} from 'react';
import {Link, Outlet} from 'react-router-dom';
import Loader from '../component/common/loader';
import Header from '../component/Header/Header';
import Footer from '../component/Footer/Footer';
import ProfileHeader from "../component/ProfileHeader/ProfileHeader";
import ProfileSidebar from "../component/ProfileSidebar/ProfileSidebar";
import EnrolldStudentCourseCard from "../pages/EnrolldStudentList/EnrolldStudentCourseCard"
import './scss/ProfileLayot.scss'
import {courseAction} from "../store/courseSlice";
import {useDispatch} from "react-redux";

const CourseWiseLayout = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        if (!window.location.href.toString().includes("/courses-list-new"))
            dispatch(courseAction.setSearchParam(""));
    }, [window.location.href]);
    return(
        <Fragment>
            <div className="profile-wrapper">
                <Header />
                <div className="profile-layout-full">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3">
                                <ProfileSidebar />
                            </div>
                            <div className="col-lg-9">
                                <ProfileHeader />
                                <EnrolldStudentCourseCard />
                                <Outlet />
                                <Loader />
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
        </Fragment>
    )
}
export default CourseWiseLayout;